import { render, staticRenderFns } from "./LearningGoalShow.vue?vue&type=template&id=909e37ce&"
import script from "./LearningGoalShow.vue?vue&type=script&lang=js&"
export * from "./LearningGoalShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports